module.exports = __webpack_public_path__ + "static/images/icon-popup4.715550a.png";